export default "__VITE_ASSET__CxRaHOea__"